import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9a153c36"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["title"]
const _hoisted_2 = { class: "name" }

import { toRefs } from 'vue'
import { slugToTitle } from '@/utils'


export default /*#__PURE__*/_defineComponent({
  __name: 'ThemeCard',
  props: {
    theme: null
  },
  emits: ["selected"],
  setup(__props: any, { emit }: { emit: ({ (e: 'selected', theme: Theme): void }), expose: any, slots: any, attrs: any }) {

const props = __props as { theme: Theme };


const { theme } = toRefs(props)



const name = theme.value.name ? theme.value.name : slugToTitle(theme.value.id)

const thumbnailStyles: Record<string, string> = {
  'background-color': theme.value.thumbnailColor
}

if (theme.value.thumbnailUrl) {
  thumbnailStyles['background-image'] = `url(${theme.value.thumbnailUrl})`
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([{ selected: _unref(theme).selected }, "theme"]),
    style: thumbnailStyles,
    title: `设置为 ${_unref(name)}`,
    role: "button",
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('selected', _unref(theme))))
  }, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(name)), 1)
  ], 10, _hoisted_1))
}
}

})